import axios from 'axios';
import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postAccounts({ body }) {
  return axios.post(
    `${process.env.REACT_APP_REST_AUTH_URL}${REST.REGISTER}`,
    body
  );
}

function putAccounts({ body, id }) {
  return BaseService.put(REST.ACCOUNTS_ID(id), body);
}

function getAccounts(params) {
  return BaseService.get(REST.ACCOUNTS, {
    params: paramsFilter({ params }),
  });
}

function deleteAccounts({ id }) {
  return BaseService.delete(REST.ACCOUNTS_ID(id));
}

export default {
  postAccounts,
  putAccounts,
  getAccounts,
  deleteAccounts,
};
